import {
    type GetAllCommercialOpportunityRequestsResponseType,
    type GetAllCommercialOpportunityRequestsRequestType
} from "./type";
import {
    request
} from "../request";

const getAllCommercialOpportunityRequests = async (
    params: GetAllCommercialOpportunityRequestsRequestType
): Promise<GetAllCommercialOpportunityRequestsResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllCommercialOpportunityRequests?${queryStr}` : "/request/getAllCommercialOpportunityRequests";

    return await request<GetAllCommercialOpportunityRequestsResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllCommercialOpportunityRequests;
